class ProductExtraInformation extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger.elements.forEach(el =>
      this.listeners.add(
        el,
        'click',
        this.onPanelTriggerHandler.bind(this, event),
      ),
    )
  }

  onPanelTriggerHandler () {
    const triggerKey = event.target.dataset.productExtraInformationTriggerkey

    this.els.panel.elements.forEach(panel => {
      if (triggerKey === panel.id) {
        panel.setAttribute('aria-hidden', false)
      } else {
        panel.setAttribute('aria-hidden', true)
      }
    })

    this.externalEls.trigger.elements.forEach((trigger, index) => {
      trigger.setAttribute(
        'aria-expanded',
        triggerKey === trigger.dataset.productExtraInformationTriggerkey,
      )
      trigger.setAttribute(
        'aria-disabled',
        triggerKey === trigger.dataset.productExtraInformationTriggerkey,
      )
    })
  }
}

if (!customElements.get('product-extra-information')) {
  customElements.define('product-extra-information', ProductExtraInformation)
}
